// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5449ed8a","453":"37e9fda1","455":"69134acc","977":"3568972d"}[chunkId] + ".chunk.js";
};